import React, { useState } from "react";
import { Tooltip } from "./Tooltip";
import { Building2, MessageSquareHeart } from "lucide-react";

export const InfluencerBrandsInterest = ({ userDatas }) => {
  const [showAll] = useState(false);
  const itemsToShow = showAll
    ? userDatas?.brand_affinity
    : userDatas?.brand_affinity?.slice(0, 4);

  const interestItemsToShow = showAll
    ? userDatas?.audience_followers_interests
    : userDatas?.audience_followers_interests?.slice(0, 4);

  if (
    !userDatas?.brand_affinity?.length &&
    !userDatas?.brand_affinity_interest?.length
  ) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full mb-5 px-4 sm:px-6">
      {/* Brands Card */}
      <div className="bg-white rounded-2xl p-4 sm:p-6 border border-green-100 shadow-sm hover:shadow-lg transition-all duration-300 w-full">
        <div className="flex items-center gap-3 mb-6 w-full">
          <div className="p-3 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl shadow-lg flex-shrink-0">
            <Building2 className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2 ">
              Mentioned Brands
              <Tooltip description="We determine brands the influencer mentioned by analyzing posts for caption texts, @mentions, #hashtags and location tags." />
            </h3>
            <p className="text-sm text-gray-500 mt-1 truncate">
              {userDatas?.brand_affinity?.length || 0} brand collaborations
            </p>
          </div>
        </div>

        <div className="space-y-1 w-full">
          {itemsToShow?.map((brand, index) => (
            <div key={index} className="flex items-center justify-between p-2">
              <div className="flex items-center gap-4 w-full min-w-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-xl flex items-center justify-center shadow-sm border border-green-200 flex-shrink-0">
                  <Building2 className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-gray-900 font-semibold block text-base sm:text-lg truncate">
                    {brand?.brand_name}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View More Toggle */}
        {/* {userDatas?.brand_affinity?.length > 4 && (
            <div className="mt-6 pt-4 border-t border-green-100 w-full">
              <button
                onClick={() => setShowAll(!showAll)}
                className="w-full py-3 px-4 bg-green-500 text-white rounded-xl font-semibold hover:bg-green-600 transition-all duration-200 shadow-lg shadow-green-500/25 hover:shadow-xl hover:shadow-green-500/30 flex items-center justify-center gap-2"
              >
                <TrendingUp className="w-4 h-4" />
                {showAll ? "Show Less Brands" : `View All ${userDatas?.brand_affinity?.length} Brands`}
              </button>
            </div>
          )} */}
      </div>

      <div className="bg-white rounded-2xl p-4 sm:p-6 border border-green-100 shadow-sm hover:shadow-lg transition-all duration-300 w-full">
        <div className="flex items-center gap-3 mb-6 w-full">
          <div className="p-3 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl shadow-lg flex-shrink-0">
            <MessageSquareHeart className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2 ">
              Influencer interests
              <Tooltip description="We determine interests by analyzing posts for caption texts, @mentions, #hashtags and location tags." />
            </h3>
            <p className="text-sm text-gray-500 mt-1 truncate">
              {userDatas?.audience_followers_interests?.length || 0} interests
              collaborations
            </p>
          </div>
        </div>

        <div className="space-y-1 w-full">
          {interestItemsToShow?.map((interest, index) => (
            <div key={index} className="flex items-center justify-between p-2">
              <div className="flex items-center gap-4 w-full min-w-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-xl flex items-center justify-center shadow-sm border border-green-200 flex-shrink-0">
                  <MessageSquareHeart className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-gray-900 font-semibold block text-base sm:text-lg truncate">
                    {interest?.name}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
